document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const menu = document.querySelector('[data-nvx-mobile-menu]');
  const menuOpeners = document.querySelectorAll('[data-nvx-menu-open]');
  const menuCloser = document.querySelector('[data-nvx-menu-close]');
  const search = document.querySelector('[data-nvx-search]');
  const searchToggle = document.querySelector('[data-nvx-search-toggle]');

  const setMenu = (open) => {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    body.classList.toggle('nvx-menu-open', open);
    menuOpeners.forEach((button) => button.setAttribute('aria-expanded', String(open)));
  };

  menuOpeners.forEach((button) => button.addEventListener('click', () => setMenu(true)));
  menuCloser?.addEventListener('click', () => setMenu(false));

  searchToggle?.addEventListener('click', () => {
    const open = !search?.classList.contains('is-open');
    search?.classList.toggle('is-open', open);
    searchToggle.setAttribute('aria-expanded', String(open));
    if (open) search?.querySelector('input')?.focus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    setMenu(false);
    search?.classList.remove('is-open');
    searchToggle?.setAttribute('aria-expanded', 'false');
  });

  document.querySelectorAll('[data-nvx-filter-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const filters = document.querySelector('[data-nvx-filters]');
      filters?.classList.add('is-open');
      body.classList.add('nvx-menu-open');
    });
  });

  document.querySelectorAll('[data-nvx-filter-close]').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelector('[data-nvx-filters]')?.classList.remove('is-open');
      body.classList.remove('nvx-menu-open');
    });
  });

  document.querySelectorAll('[data-nvx-auto-submit]').forEach((input) => {
    input.addEventListener('change', () => input.form?.submit());
  });

  document.querySelectorAll('[data-nvx-pdp]').forEach((pdp) => {
    const mainImage = pdp.querySelector('[data-nvx-main-image]');
    const thumbs = pdp.querySelectorAll('[data-nvx-thumb]');
    const variantSelect = pdp.querySelector('[data-nvx-variant-select]');
    const variantInput = pdp.querySelector('[data-nvx-variant-id]');
    const price = pdp.querySelector('[data-nvx-price]');
    const compare = pdp.querySelector('[data-nvx-compare]');
    const stock = pdp.querySelector('[data-nvx-stock]');
    const addButton = pdp.querySelector('[data-nvx-add]');
    const addText = addButton?.querySelector('span');
    const quantity = pdp.querySelector('[data-nvx-quantity]');

    const setMainImage = (src) => {
      if (!src || !mainImage) return;

      // The first image is rendered with a responsive srcset. If only `src`
      // changes, the browser can keep selecting the old file from that srcset.
      // Remove the responsive candidates before assigning the selected image.
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = src;
    };

    const activateImage = (src, button) => {
      setMainImage(src);
      thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => activateImage(thumb.dataset.image, thumb)));

    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      if (!option) return;
      if (variantInput) variantInput.value = option.value;
      if (price) price.textContent = option.dataset.price || '';
      if (compare) {
        const onSale = option.dataset.onSale === 'true';
        compare.hidden = !onSale;
        compare.textContent = onSale ? (option.dataset.compare || '') : '';
      }
      const available = option.dataset.available === 'true';
      if (stock) {
        stock.textContent = available ? (stock.dataset.inStock || 'In stock') : (stock.dataset.outOfStock || 'Out of stock');
        stock.classList.toggle('is-out', !available);
      }
      if (addButton) addButton.disabled = !available;
      if (addText) addText.textContent = available ? (addText.dataset.available || 'Add to cart') : (addText.dataset.soldOut || 'Sold out');
      if (option.dataset.image) setMainImage(option.dataset.image);
    });

    pdp.querySelector('[data-nvx-qty-minus]')?.addEventListener('click', () => {
      if (!quantity) return;
      quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1));
    });

    pdp.querySelector('[data-nvx-qty-plus]')?.addEventListener('click', () => {
      if (!quantity) return;
      quantity.value = String(Number(quantity.value || 1) + 1);
    });

    const dialog = pdp.querySelector('[data-nvx-dialog]');
    pdp.querySelector('[data-nvx-fullscreen]')?.addEventListener('click', () => {
      const dialogImage = dialog?.querySelector('img');
      if (dialogImage && mainImage) dialogImage.src = mainImage.src;
      dialog?.showModal();
    });
    pdp.querySelector('[data-nvx-dialog-close]')?.addEventListener('click', () => dialog?.close());
  });

  document.querySelectorAll('[data-nvx-cart-quantity]').forEach((input) => {
    const form = input.form;
    const update = () => form?.requestSubmit();
    input.closest('.nvx-quantity')?.querySelector('[data-nvx-cart-minus]')?.addEventListener('click', () => {
      input.value = String(Math.max(0, Number(input.value || 1) - 1));
      update();
    });
    input.closest('.nvx-quantity')?.querySelector('[data-nvx-cart-plus]')?.addEventListener('click', () => {
      input.value = String(Number(input.value || 1) + 1);
      update();
    });
    input.addEventListener('change', update);
  });
});

/* Collection hero: reconnects safely in the Shopify theme editor. */
if (!customElements.get('nvx-hero-slider')) {
  customElements.define('nvx-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.controls = this.querySelector('.nvx-hero-controls');
      if (this.slides.length < 2) return;
      this.index = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.events = new AbortController();
      const on = (target, event, fn) => target.addEventListener(event, fn, { signal: this.events.signal });
      this.controls.hidden = false;
      this.pauseButton = this.querySelector('[data-hero-pause]');
      on(this.querySelector('[data-hero-prev]'), 'click', () => this.show(this.index - 1));
      on(this.querySelector('[data-hero-next]'), 'click', () => this.show(this.index + 1));
      on(this.pauseButton, 'click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); });
      on(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
      on(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => { this.focused = true; this.schedule(); });
      on(this, 'focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => { this.paused = this.motion.matches; this.updatePause(); this.schedule(); });
      this.updatePause();
      this.show(0);
    }
    updatePause() {
      this.pauseButton.textContent = this.paused ? 'Play' : 'Pause';
      this.pauseButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== this.index;
        if (i === this.index) slide.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
      });
      this.querySelector('[data-hero-status]').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.paused && !this.hovered && !this.focused && !document.hidden) {
        this.timer = setTimeout(() => this.show(this.index + 1), 5000);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.events?.abort();
    }
  });
}
